import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

async function bootstrap() {
  if (import.meta.env.DEV && import.meta.env.VITE_DEV_MOCK_TELEGRAM === 'true') {
    const { mockTelegramEnv } = await import('@telegram-apps/sdk-react');
    mockTelegramEnv({
      platform: 'web',
      version: '7.0',
      themeParams: {
        bgColor: '#eef5ec',
        textColor: '#16271d',
        buttonColor: '#54992b',
        buttonTextColor: '#ffffff',
        secondaryBgColor: '#dce8dc',
        hintColor: '#6c7d70',
        linkColor: '#0c9981',
      },
      initDataRaw: import.meta.env.VITE_DEV_INIT_DATA ?? '',
    });
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap();
